var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-box", on: { click: _vm.selectMethod } },
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.checkout.paymentMethod,
              expression: "checkout.paymentMethod"
            }
          ],
          attrs: {
            type: "radio",
            name: "payment",
            id: _vm.idlist,
            id: "payment-method-" + _vm.payment.id
          },
          domProps: {
            value: _vm.payment.id,
            checked: _vm._q(_vm.checkout.paymentMethod, _vm.payment.id)
          },
          on: {
            change: [
              function($event) {
                return _vm.$set(_vm.checkout, "paymentMethod", _vm.payment.id)
              },
              function($event) {
                return _vm.$emit("change", _vm.payment.id)
              }
            ]
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticStyle: {
              display: "flex",
              "padding-left": "0.4em",
              "justify-content": "space-between",
              margin: "auto"
            },
            attrs: { for: _vm.idlist }
          },
          [
            _vm.payment.id == 6
              ? _c("span", [
                  _vm._v(_vm._s(_vm.strings["payment_method_credit_card"]))
                ])
              : _vm.payment.id == 7
              ? _c("span", [
                  _vm._v(_vm._s(_vm.strings["payment_method_home_bancking"]))
                ])
              : _c("span", [_vm._v(_vm._s(_vm.payment.label))])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.payment.id === 3
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { width: "80px", "margin-top": "0.5em" } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 82 20"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M30.625 4.473h-4.532a.63.63 0 0 0-.622.532l-1.833 11.622a.377.377 0 0 0 .373.436h2.164a.63.63 0 0 0 .622-.532l.495-3.135a.63.63 0 0 1 .621-.532h1.435c2.986 0 4.709-1.445 5.159-4.308.203-1.252.009-2.237-.578-2.926-.644-.757-1.787-1.157-3.304-1.157Zm.523 4.245c-.248 1.626-1.49 1.626-2.692 1.626h-.684l.48-3.037a.378.378 0 0 1 .373-.319h.314c.818 0 1.59 0 1.99.467.237.278.31.692.22 1.263ZM44.173 8.665h-2.17a.378.378 0 0 0-.373.32l-.096.606-.152-.22c-.47-.682-1.518-.91-2.563-.91-2.399 0-4.447 1.817-4.846 4.365-.208 1.271.087 2.487.808 3.334.662.78 1.608 1.104 2.734 1.104 1.932 0 3.004-1.242 3.004-1.242l-.097.603a.378.378 0 0 0 .373.437h1.955a.63.63 0 0 0 .622-.532l1.173-7.429a.376.376 0 0 0-.372-.436Zm-3.025 4.225c-.21 1.24-1.194 2.072-2.449 2.072-.63 0-1.134-.202-1.457-.585-.32-.38-.443-.922-.34-1.525.195-1.23 1.195-2.089 2.431-2.089.617 0 1.118.205 1.448.591.33.39.462.935.367 1.536ZM55.733 8.665h-2.181a.632.632 0 0 0-.522.277l-3.008 4.43-1.275-4.257a.632.632 0 0 0-.605-.45H46a.378.378 0 0 0-.358.5l2.402 7.05-2.258 3.188a.378.378 0 0 0 .308.597h2.178c.207 0 .4-.1.518-.27l7.254-10.472a.378.378 0 0 0-.31-.593Z",
                        fill: "#253B80"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M62.954 4.473H58.42a.63.63 0 0 0-.622.532l-1.833 11.622a.377.377 0 0 0 .372.436h2.327a.44.44 0 0 0 .434-.373l.52-3.294a.629.629 0 0 1 .622-.532h1.434c2.987 0 4.709-1.445 5.16-4.308.203-1.252.008-2.237-.579-2.926-.643-.757-1.785-1.157-3.302-1.157Zm.523 4.245c-.248 1.626-1.49 1.626-2.692 1.626H60.1l.48-3.037a.376.376 0 0 1 .373-.319h.314c.818 0 1.59 0 1.99.467.237.278.31.692.219 1.263ZM76.499 8.665h-2.17a.376.376 0 0 0-.372.32l-.096.606-.153-.22c-.47-.682-1.517-.91-2.562-.91-2.399 0-4.447 1.817-4.846 4.365-.206 1.271.087 2.487.808 3.334.663.78 1.608 1.104 2.734 1.104 1.933 0 3.004-1.242 3.004-1.242l-.097.603a.378.378 0 0 0 .374.437h1.955a.63.63 0 0 0 .621-.532l1.174-7.429a.378.378 0 0 0-.374-.436Zm-3.026 4.225c-.208 1.24-1.193 2.072-2.449 2.072-.629 0-1.133-.202-1.457-.585-.32-.38-.441-.922-.34-1.525.196-1.23 1.196-2.089 2.432-2.089.616 0 1.117.205 1.447.591.332.39.463.935.367 1.536ZM79.057 4.792l-1.86 11.835a.377.377 0 0 0 .372.436h1.87c.31 0 .575-.226.622-.532l1.835-11.622a.378.378 0 0 0-.373-.437H79.43a.379.379 0 0 0-.372.32Z",
                        fill: "#179BD7"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "m4.815 19.322.347-2.202-.772-.018H.703L3.265.857a.21.21 0 0 1 .208-.178H9.69c2.063 0 3.488.43 4.231 1.277.349.398.57.813.678 1.27.113.48.115 1.054.005 1.753l-.008.05v.449l.348.197c.294.156.527.334.706.538.298.34.491.772.573 1.285.084.527.056 1.154-.082 1.863-.159.817-.416 1.528-.763 2.11a4.34 4.34 0 0 1-1.21 1.325 4.906 4.906 0 0 1-1.629.735c-.6.157-1.285.236-2.035.236h-.484c-.346 0-.682.124-.946.347-.264.228-.44.54-.493.88l-.036.199-.613 3.88-.028.142c-.007.046-.02.068-.038.083a.103.103 0 0 1-.064.024H4.815Z",
                        fill: "#253B80"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M15.274 5.081c-.018.119-.04.24-.063.365-.82 4.209-3.625 5.663-7.207 5.663H6.181a.886.886 0 0 0-.876.75l-.934 5.922-.264 1.679a.467.467 0 0 0 .46.54h3.235a.779.779 0 0 0 .77-.657l.03-.164.61-3.865.039-.212a.778.778 0 0 1 .769-.658h.484c3.134 0 5.587-1.272 6.304-4.954.3-1.538.145-2.823-.648-3.726a3.094 3.094 0 0 0-.886-.683Z",
                        fill: "#179BD7"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M14.417 4.74a6.461 6.461 0 0 0-.797-.178c-.492-.079-1.03-.117-1.608-.117H7.14a.774.774 0 0 0-.768.658l-1.037 6.565-.03.191a.886.886 0 0 1 .876-.75h1.823c3.582 0 6.387-1.455 7.207-5.663a9.53 9.53 0 0 0 .064-.365 4.373 4.373 0 0 0-.858-.342Z",
                        fill: "#222D65"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M6.371 5.102a.775.775 0 0 1 .769-.656h4.872c.577 0 1.116.037 1.608.117a6.472 6.472 0 0 1 .982.234c.241.08.466.175.673.284.244-1.555-.002-2.614-.843-3.573C13.505.452 11.832 0 9.69 0H3.474a.888.888 0 0 0-.878.75L.006 17.164c-.05.325.2.618.527.618h3.838l.964-6.114L6.37 5.102Z",
                        fill: "#253B80"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payment.id === 6 ? _c("div", [_c("div")]) : _vm._e(),
      _vm._v(" "),
      _vm.payment.id === 7
        ? _c("div", { staticStyle: { "margin-top": "0.5em" } }, [
            _c("i", { staticClass: "fal fa-coins" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payment.id === 8
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { width: "80px", "margin-top": "0.5em" } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 132 35",
                      fill: "none"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d:
                          "M0.256527 15.5036C-0.0990205 15.0963 -0.0832167 14.4871 0.292984 14.0984L4.2983 9.96013C4.71179 9.53291 5.40037 9.53291 5.81386 9.96013L8.87503 13.1229C9.28852 13.5501 9.9771 13.5501 10.3906 13.1229L13.3641 10.0507C13.7776 9.62348 14.4662 9.62348 14.8797 10.0507L18.8708 14.1743C19.2468 14.5628 19.2628 15.1716 18.9077 15.579L10.4151 25.3224C9.99624 25.8029 9.24538 25.8032 8.8262 25.3229L0.256527 15.5036ZM23.3848 22.2368L24.9814 19.7895C25.8176 20.5789 27.1101 21.0526 28.3518 21.0526C29.2388 21.0526 29.923 20.6053 29.923 19.9737C29.923 18.0526 23.9677 18.7368 23.9677 14.6316C23.9677 12.1842 26.2484 10.6579 28.6813 10.6579C30.2778 10.6579 32.0264 11.2895 32.8373 11.9474L31.2915 14.4211C30.6579 13.9474 29.8217 13.5526 28.9347 13.5526C28.0224 13.5526 27.2621 13.9211 27.2621 14.5789C27.2621 16.2368 33.2175 15.5789 33.2175 20C33.2175 22.4474 30.9114 23.9474 28.3265 23.9474C26.6286 23.9474 24.8293 23.3421 23.3848 22.2368ZM44.8747 19.1053L47.4089 21.0789C45.9644 23.0789 44.1398 23.9474 41.8337 23.9474C38.0324 23.9474 35.2448 21 35.2448 17.3158C35.2448 13.6053 38.1084 10.6579 41.859 10.6579C43.9877 10.6579 45.8884 11.6842 47.0288 13.2105L44.6973 15.3421C44.0384 14.4474 43.0501 13.8158 41.859 13.8158C39.9584 13.8158 38.5392 15.3684 38.5392 17.3158C38.5392 19.3158 39.9331 20.7895 41.9351 20.7895C43.2782 20.7895 44.3425 19.9474 44.8747 19.1053ZM58.4326 19.2105V15.3947C57.7484 14.4474 56.6587 13.8158 55.3916 13.8158C53.4656 13.8158 52.2238 15.4737 52.2238 17.3158C52.2238 19.3158 53.6176 20.7895 55.4676 20.7895C56.7094 20.7895 57.7991 20.1579 58.4326 19.2105ZM61.727 10.9211V23.6842H58.5593V22.6579C57.5456 23.5526 56.3799 23.9474 55.1382 23.9474C53.3135 23.9474 51.5903 23.1053 50.5006 21.7895C49.5376 20.6316 48.9294 19.0526 48.9294 17.3158C48.9294 13.5526 51.6156 10.6579 54.9608 10.6579C56.3546 10.6579 57.5963 11.1316 58.5593 11.9474V10.9211H61.727ZM68.8228 5V23.6842H65.5283V5H68.8228ZM81.1136 19.2105V15.3947C80.4293 14.4474 79.3396 13.8158 78.0725 13.8158C76.1466 13.8158 74.9048 15.4737 74.9048 17.3158C74.9048 19.3158 76.2986 20.7895 78.1486 20.7895C79.3903 20.7895 80.48 20.1579 81.1136 19.2105ZM84.408 10.9211V23.6842H81.2403V22.6579C80.2266 23.5526 79.0609 23.9474 77.8191 23.9474C75.9945 23.9474 74.2713 23.1053 73.1816 21.7895C72.2186 20.6316 71.6104 19.0526 71.6104 17.3158C71.6104 13.5526 74.2966 10.6579 77.6417 10.6579C79.0355 10.6579 80.2773 11.1316 81.2403 11.9474V10.9211H84.408ZM88.2093 30V10.9211H91.377V11.9474C92.34 11.1316 93.5817 10.6579 94.9755 10.6579C98.3207 10.6579 101.007 13.5526 101.007 17.3158C101.007 19.0526 100.424 20.6316 99.4611 21.7895C98.3714 23.1053 96.6228 23.9474 94.7982 23.9474C93.5564 23.9474 92.492 23.5789 91.5037 22.7895V30H88.2093ZM91.5037 15.3947V19.2105C92.1373 20.1579 93.227 20.7895 94.4687 20.7895C96.3187 20.7895 97.7125 19.3158 97.7125 17.3158C97.7125 15.4737 96.4707 13.8158 94.5447 13.8158C93.2776 13.8158 92.1879 14.4474 91.5037 15.3947ZM112.537 19.2105V15.3947C111.853 14.4474 110.764 13.8158 109.496 13.8158C107.57 13.8158 106.329 15.4737 106.329 17.3158C106.329 19.3158 107.723 20.7895 109.572 20.7895C110.814 20.7895 111.904 20.1579 112.537 19.2105ZM115.832 10.9211V23.6842H112.664V22.6579C111.65 23.5526 110.485 23.9474 109.243 23.9474C107.418 23.9474 105.695 23.1053 104.605 21.7895C103.642 20.6316 103.034 19.0526 103.034 17.3158C103.034 13.5526 105.72 10.6579 109.066 10.6579C110.459 10.6579 111.701 11.1316 112.664 11.9474V10.9211H115.832ZM123.536 30H120.089L123.485 22.3947L117.986 10.9211H121.61L125.208 18.5789L128.528 10.9211H132L123.536 30Z",
                        fill: "#272727"
                      }
                    })
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payment.id === 9
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { width: "80px", "margin-top": "0.6em" } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                      "xmlns:cc": "http://creativecommons.org/ns#",
                      "xmlns:rdf":
                        "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
                      "xmlns:svg": "http://www.w3.org/2000/svg",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:sodipodi":
                        "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
                      "xmlns:inkscape":
                        "http://www.inkscape.org/namespaces/inkscape",
                      "inkscape:version": "1.0 (4035a4fb49, 2020-05-01)",
                      "sodipodi:docname": "Logo Satispay.svg",
                      viewBox: "0 0 938.63988 220.91",
                      height: "19",
                      width: "80",
                      "xml:space": "preserve",
                      id: "svg10",
                      version: "1.1"
                    }
                  },
                  [
                    _c(
                      "metadata",
                      { attrs: { id: "metadata16" } },
                      [
                        _c(
                          "rdf:RDF",
                          [
                            _c(
                              "cc:Work",
                              { attrs: { "rdf:about": "" } },
                              [
                                _c("dc:format", [_vm._v("image/svg+xml")]),
                                _c("dc:type", {
                                  attrs: {
                                    "rdf:resource":
                                      "http://purl.org/dc/dcmitype/StillImage"
                                  }
                                }),
                                _c("dc:title")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("defs", { attrs: { id: "defs14" } }, [
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath28",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path26",
                              d: "M 0,595.276 H 841.89 V 0 H 0 Z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath94",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path92",
                              d:
                                "m 344.027,351.804 h 184.645 v 43.457 H 344.027 Z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath162",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path160",
                              d:
                                "m 344.027,204.89 h 184.645 v 43.456 H 344.027 Z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath230",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path228",
                              d:
                                "m 585.443,253.104 h 72.601 v 17.864 h -72.601 z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath282",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path280",
                              d:
                                "m 585.443,253.493 h 72.601 v 17.086 h -72.601 z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath298",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path296",
                              d:
                                "m 585.443,253.104 h 72.601 v 17.864 h -72.601 z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath314",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path312",
                              d:
                                "m 607.172,351.804 h 184.644 v 43.457 H 607.172 Z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath426",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path424",
                              d: "M 0,0 H 841.89 V 595.276 H 0 Z"
                            }
                          })
                        ]
                      ),
                      _c(
                        "clipPath",
                        {
                          attrs: {
                            id: "clipPath434",
                            clipPathUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              id: "path432",
                              d:
                                "m 321.299,271.075 h 24.228 v -24.228 h -24.228 z"
                            }
                          })
                        ]
                      )
                    ]),
                    _c("sodipodi:namedview", {
                      attrs: {
                        "inkscape:current-layer": "g18",
                        "inkscape:window-maximized": "1",
                        "inkscape:window-y": "-8",
                        "inkscape:window-x": "-8",
                        "inkscape:cy": "212.20198",
                        "inkscape:cx": "482.28805",
                        "inkscape:zoom": "0.91848149",
                        showgrid: "false",
                        id: "namedview12",
                        "inkscape:window-height": "961",
                        "inkscape:window-width": "1280",
                        "inkscape:pageshadow": "2",
                        "inkscape:pageopacity": "0",
                        guidetolerance: "10",
                        gridtolerance: "10",
                        objecttolerance: "10",
                        borderopacity: "1",
                        bordercolor: "#666666",
                        pagecolor: "#ffffff"
                      }
                    }),
                    _c(
                      "g",
                      {
                        attrs: {
                          transform:
                            "matrix(1.3333333,0,0,-1.3333333,-84.171364,689.98197)",
                          "inkscape:label": "guida-partner-satispay",
                          "inkscape:groupmode": "layer",
                          id: "g18"
                        }
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              transform:
                                "matrix(3.8126235,0,0,3.8126235,-1248.5169,-989.49222)",
                              id: "g88"
                            }
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  "clip-path": "url(#clipPath94)",
                                  id: "g90"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(398.4984,366.9208)",
                                      id: "g96"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path98",
                                        d:
                                          "m 0,0 h 0.323 c 1.891,-0.402 3.582,-0.684 5.232,-0.684 2.496,0 4.307,0.604 4.307,2.737 0,3.944 -9.781,2.375 -9.781,8.895 0,3.542 3.3,5.434 7.446,5.434 1.651,0 3.301,-0.241 4.83,-0.724 V 12.68 h -0.322 c -1.731,0.562 -3.22,0.804 -4.548,0.804 -1.972,0 -4.025,-0.443 -4.025,-2.536 0,-3.742 9.78,-2.253 9.78,-8.572 0,-4.59 -3.702,-5.958 -7.808,-5.958 -2.013,0 -4.025,0.282 -5.434,0.605 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(444.6626,364.0634)",
                                      id: "g100"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path102",
                                        d:
                                          "m 0,0 c -1.127,-0.403 -2.415,-0.724 -4.025,-0.724 -1.973,0 -5.071,0.443 -5.071,4.991 v 11.592 h -2.497 v 2.817 h 2.497 v 4.508 l 2.857,0.604 h 0.322 v -5.112 h 6.2 v -2.817 h -6.2 V 4.347 c 0,-2.052 1.731,-2.214 2.535,-2.214 0.806,0 2.093,0.282 3.1,0.604 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(456.4527,366.9208)",
                                      id: "g104"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path106",
                                        d:
                                          "m 0,0 h 0.322 c 1.892,-0.402 3.583,-0.684 5.233,-0.684 2.496,0 4.307,0.604 4.307,2.737 0,3.944 -9.781,2.375 -9.781,8.895 0,3.542 3.3,5.434 7.446,5.434 1.65,0 3.301,-0.241 4.83,-0.724 V 12.68 h -0.322 c -1.731,0.562 -3.221,0.804 -4.548,0.804 -1.972,0 -4.026,-0.443 -4.026,-2.536 0,-3.742 9.781,-2.253 9.781,-8.572 0,-4.59 -3.702,-5.958 -7.808,-5.958 -2.013,0 -4.025,0.282 -5.434,0.605 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(477.1793,366.6396)",
                                      id: "g108"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path110",
                                        d:
                                          "m 0,0 c 1.249,-0.201 2.576,-0.403 4.267,-0.403 3.944,0 6.44,2.496 6.44,7.367 0,4.508 -1.49,6.801 -4.709,6.801 -1.893,0 -3.986,-0.804 -5.998,-2.576 z m -3.22,16.06 2.817,0.604 H 0 v -2.456 c 1.892,1.409 3.945,2.456 6.722,2.456 4.146,0 7.365,-2.939 7.365,-9.218 C 14.087,1.288 10.868,-3.3 4.146,-3.3 2.576,-3.3 1.328,-3.099 0,-2.817 v -9.378 l -2.817,-0.604 H -3.22 Z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(517.9495,364.1046)",
                                      id: "g112"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path114",
                                        d:
                                          "m 0,0 -6.49,18.635 h 3.702 L 1.771,3.984 h 0.281 l 5.007,14.651 h 3.663 L 3.623,-0.926 c -1.691,-4.83 -3.785,-7.165 -7.246,-9.338 l -1.811,2.335 c 3.502,2.495 4.387,3.904 5.715,7.164"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(505.4324,372.6371)",
                                      id: "g116"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path118",
                                        d:
                                          "m 0,0 -5.192,-0.765 c -1.368,-0.201 -2.899,-0.765 -2.899,-2.937 0,-1.571 1.089,-2.658 2.738,-2.658 1.771,0 3.784,1.128 5.353,2.254 z M 3.22,-8.694 0.604,-9.218 H 0.161 v 2.657 H 0.08 c -1.69,-1.288 -3.743,-2.617 -6.52,-2.617 -2.455,0 -5.031,1.772 -5.031,5.234 0,4.667 4.186,5.312 6.44,5.635 L 0,2.375 v 1.287 c 0,3.221 -1.529,4.106 -4.306,4.106 -1.047,0 -3.663,-0.322 -5.796,-1.288 l -0.363,2.978 c 1.772,0.685 4.549,1.208 6.763,1.208 3.983,0 6.922,-1.65 6.922,-7.004 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(426.1484,368.5312)",
                                      id: "g120"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path122",
                                        d:
                                          "m 0,0 c -1.569,-1.126 -3.582,-2.254 -5.353,-2.254 -1.65,0 -2.738,1.086 -2.738,2.657 0,2.173 1.531,2.737 2.899,2.938 L 0,4.106 Z m 3.22,7.768 c 0,5.354 -2.939,7.004 -6.923,7.004 -2.213,0 -4.991,-0.524 -6.762,-1.208 l 0.363,-2.978 c 2.133,0.966 4.749,1.288 5.796,1.288 C -1.529,11.874 0,10.988 0,7.768 V 6.48 L -5.031,5.796 c -2.254,-0.322 -6.44,-0.967 -6.44,-5.634 0,-3.462 2.576,-5.234 5.031,-5.234 2.777,0 4.83,1.329 6.52,2.617 h 0.081 v -2.657 h 0.443 l 2.616,0.524 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(448.6055,363.4194)",
                                      id: "g124"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path126",
                                        d: "M 0,0 H 0.013 L 0,0.014 Z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(451.4229,383.3034)",
                                      id: "g128"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path130",
                                        d:
                                          "m 0,0 -2.817,-0.604 v -17.089 -2.177 l 0.012,-0.013 h 0.403 l 2.805,0.6 V -18.326 0 Z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(451.4229,389.8325)",
                                      id: "g132"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path134",
                                        d:
                                          "m 0,0 -2.817,-0.604 v -1.232 -2.177 l 0.012,-0.014 h 0.403 l 2.805,0.601 V -2.469 0 Z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(477.1793,374.7433)",
                                      id: "g136"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path138",
                                        d:
                                          "m 0,0 c 0,-0.89 -0.721,-1.61 -1.61,-1.61 -0.889,0 -1.61,0.72 -1.61,1.61 0,0.889 0.721,1.61 1.61,1.61 C -0.721,1.61 0,0.889 0,0"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(378.7471,394.1002)",
                                      id: "g140"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path142",
                                        d:
                                          "m 0,0 c 0.428,0.428 0.125,1.16 -0.481,1.16 h -10.083 l 5.863,-5.861 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(364.6564,380.0093)",
                                      id: "g144"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path146",
                                        d:
                                          "m 0,0 -7.211,7.211 -6.489,-6.49 -6.73,-6.73 c -0.266,-0.265 -0.266,-0.696 0,-0.961 l 6.73,-6.731 6.489,-6.489 7.211,7.211 -6.009,6.009 -0.481,0.48 0.481,0.481 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(374.0457,357.6413)",
                                      id: "g148"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path150",
                                        d:
                                          "M 0,0 -5.838,-5.838 H 4.197 c 0.605,0 0.909,0.732 0.481,1.16 z"
                                      }
                                    })
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform: "translate(387.2654,374.0003)",
                                      id: "g152"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      staticStyle: {
                                        fill: "#ef373f",
                                        "fill-opacity": "1",
                                        "fill-rule": "nonzero",
                                        stroke: "none"
                                      },
                                      attrs: {
                                        id: "path154",
                                        d:
                                          "m 0,0 -6.73,6.73 -7.579,7.579 -6.752,6.752 c -0.122,0.122 -0.287,0.189 -0.459,0.195 -0.007,0 -0.014,0.004 -0.022,0.004 h -12.499 c -0.605,0 -0.908,-0.732 -0.48,-1.16 l 5.791,-5.791 7.21,-7.211 7.099,-7.098 0.48,-0.481 -0.48,-0.48 -7.099,-7.098 -7.21,-7.211 -5.767,-5.767 c -0.428,-0.428 -0.125,-1.16 0.48,-1.16 h 12.495 0.005 c 0.18,0 0.353,0.072 0.48,0.199 l 6.728,6.728 7.579,7.578 L 0,-0.961 C 0.266,-0.696 0.266,-0.266 0,0"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }